import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export function useOrderId() {
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const [orderId, setOrderId] = useState(params.get("id"));

    useEffect(() => {
        if (!params.get("id")) {
            // After auth redirect from Shopify, we lost the order id in the redirects chain, 
            // so we'll restore it from session storage
            const sessionOrderId = sessionStorage.getItem("orderId");
            if (sessionOrderId) {
                console.info("Restoring order id from session storage: ", sessionOrderId);
                setOrderId(sessionOrderId);

                history.replaceState(null, "", `/?id=${sessionOrderId}`)
            }
        }
    }, []);

    return orderId;
}

export function saveOrderIdToSessionStorage(params: URLSearchParams) {
    const orderId = params.get("id");
    if (orderId) {
        console.info("Saving order id to session storage: ", orderId);
        sessionStorage.setItem("orderId", orderId);
    }
}